module.exports = __webpack_public_path__ + "static/media/avatar-3.8710758d.png";